//
//Returns the fraction of a circle this object represents. Fraction must be
//between 0 and 1.
//
//
//This should be implemented, because the name for every fraction should be
//different.
//
//@inheritDoc
//
//These are not implemented, because they are easier to implement for
//specific fractions.
import Length from "./Length";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class CircleFraction extends AbstractShape {
	static NAME = "quarter-circle";

	constructor( diameter ) {
		super();

		this.diameter = diameter;
	}

	get_area() {
		const radius = this.diameter.in_mm() / 2;
		const area = Math.PI * Math.pow( radius, 2 );
		return new Area( this.get_fraction() * area );
	}

	get_circumference() {
		const circle_circumference = new Length( Math.PI * this.diameter.in_mm() );

		if ( this.get_fraction() === +1 ) {
			return circle_circumference;
		}

		return new Length( this.get_fraction() * circle_circumference.in_mm() + this.diameter.in_mm() );
	}

	get_diameter() {
		return this.diameter;
	}

	get_dimension_keys() {
		return ["diameter"];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			diameter: this.diameter.in_mm()
		};
	}

	static deserialize_primitives( primitives ) //The circle with radius has never been on production, but this makes sure on test we show the correct circle.
	{
		if ( !( undefined !== primitives.diameter ) && undefined !== primitives.radius ) {
			primitives.diameter = primitives.radius * 2;
		}

		return new this( new Length( primitives.diameter ) );
	}

}
